import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import Axios from "axios";
import { useNavigate } from "react-router-dom";
import { isBrowser } from "react-device-detect";
import { useSelector } from "react-redux";

//STYLES
import * as ControllerStyles from "../styles/controller";

//COMPONENTS
import Product from "./product";

function Controller(props) {
    const navigate = useNavigate();
    const printingShop = useSelector((state) => state.printingShop);

    const [products, setProducts] = useState([]);
    const [mobileIndex, setMobileIndex] = useState([]);
    const [policies, setPolicies] = useState({
        policies: [],
        length: 3
    });

    let items = 21;

    useEffect(() => {
        onLoad();
        // let rows = Math.round(items / 2);
        // console.log(rows);
    }, []);

    function onLoad() {
        Axios.post("/pods/3dPrintingShop/frontEnd/getProducts")
            .then((res) => {
                const data = res.data;
                console.log(data);
                if (data.error == "null") {
                    if (printingShop.settings.frontLayout == "mixedItems") {
                        setProducts(data.products);
                    }
                    if (printingShop.settings.frontLayout == "byCategory") {
                        setProducts(data.categories);
                    }
                    setMobileIndex(data.mobileIndex);

                    // let length = 3;
                    // if (data.policies.length == 3) {
                    //     length = 4;
                    // }
                    // if (data.policies.length == 2) {
                    //     length = 6;
                    // }
                    // if (data.policies.length == 1) {
                    //     length = 12;
                    // }

                    // setPolicies({ policies: data.policies, length: length });
                }
            })
            .catch((err) => console.log(err));
    }

    function handleClick(code) {
        navigate(`./product/${code}`);
    }

    const browserDisplay = (
        <div>
            <Row>
                <Col sm={2}></Col>
                <Col sm={8} style={ControllerStyles.itemContainer}>
                    {products.length == 0 ? (
                        <div style={ControllerStyles.shopClosedSign}>The shop is Closed</div>
                    ) : (
                        <>
                            {printingShop.settings.frontLayout == "mixedItems" && (
                                <Row>
                                    {products.map((product, index) => {
                                        return (
                                            <Col key={index} sm={3}>
                                                <Product product={product} click={handleClick} mobile={false} />
                                            </Col>
                                        );
                                    })}
                                </Row>
                            )}
                            {printingShop.settings.frontLayout == "byCategory" && (
                                <>
                                    {products.map((category, index) => {
                                        return (
                                            <div key={index}>
                                                <h3>{category.name}</h3>
                                                <Row>
                                                    {category.products.map((product, index) => {
                                                        return (
                                                            <Col key={index} sm={3}>
                                                                <Product product={product} click={handleClick} mobile={false} />
                                                            </Col>
                                                        );
                                                    })}
                                                </Row>
                                                <br />
                                                <br />
                                            </div>
                                        );
                                    })}
                                </>
                            )}
                        </>
                    )}
                </Col>
                <Col sm={2}></Col>
            </Row>
            {/* <Row>
                <Col sm={2}></Col>
                <Col>
                    <Row>
                        {policies.policies.map((policy, index) => {
                            return (
                                <Col sm={policies.length} key={index} style={ControllerStyles.link}>
                                    <div onClick={handlePolicyClick.bind(this, policy.fileName)} style={ControllerStyles.linkText}>
                                        {policy.name}
                                    </div>
                                </Col>
                            );
                        })}
                    </Row>
                </Col>
                <Col sm={2}></Col>
            </Row> */}
        </div>
    );

    const mobileDisplay = (
        <div>
            <br />
            {products.length > 0 && (
                <div>
                    {printingShop.settings.frontLayout == "mixedItems" && (
                        <>
                            {mobileIndex.map((productRow, index) => {
                                return (
                                    <div key={index} style={ControllerStyles.mobile_productRow}>
                                        {productRow.column1 != "NA" && (
                                            <div style={ControllerStyles.mobile_productContainer}>
                                                <Product
                                                    key={0}
                                                    product={products.find((product) => product.uuid == productRow.column1)}
                                                    click={handleClick}
                                                    mobile={true}
                                                />
                                            </div>
                                        )}
                                        {productRow.column2 != "NA" && (
                                            <div style={ControllerStyles.mobile_productContainer}>
                                                <Product
                                                    key={0}
                                                    product={products.find((product) => product.uuid == productRow.column2)}
                                                    click={handleClick}
                                                    mobile={true}
                                                />
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </>
                    )}
                    {printingShop.settings.frontLayout == "byCategory" && (
                        <>
                            {products.map((category, index) => {
                                return (
                                    <div key={index}>
                                        <h3>{category.name}</h3>
                                        {category.mobileIndex.map((productRow, index) => {
                                            return (
                                                <div key={index} style={ControllerStyles.mobile_productRow}>
                                                    {productRow.column1 != "NA" && (
                                                        <div style={ControllerStyles.mobile_productContainer}>
                                                            <Product
                                                                key={0}
                                                                product={category.products.find((product) => product.uuid == productRow.column1)}
                                                                click={handleClick}
                                                                mobile={true}
                                                            />
                                                        </div>
                                                    )}
                                                    {productRow.column2 != "NA" && (
                                                        <div style={ControllerStyles.mobile_productContainer}>
                                                            <Product
                                                                key={0}
                                                                product={category.products.find((product) => product.uuid == productRow.column2)}
                                                                click={handleClick}
                                                                mobile={true}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                        <br /> <br />
                                    </div>
                                );
                            })}
                        </>
                    )}
                </div>
            )}
            {/* <div style={ControllerStyles.mobile_policyContainer}>
                {policies.policies.map((policy, index) => {
                    return (
                        <div key={index} onClick={handlePolicyClick.bind(this, policy.fileName)} style={ControllerStyles.linkText}>
                            {policy.name}
                        </div>
                    );
                })}
            </div> */}
        </div>
    );

    return <div>{isBrowser ? browserDisplay : mobileDisplay}</div>;
}

export default Controller;
